import React from 'react';
import styled from 'styled-components';

interface Props {
	index: number;
	value: string;
	handleInputChange: any;
}

const PurchaseTotalTextInput = ({ index, value, handleInputChange }: Props) => {
	const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const regex = /^\d*\.?\d{0,2}$/;
		let value = event.target.value;
		// If the value starts with a decimal, prepend '0'
		if (value.startsWith('.')) {
			value = '0' + value;
		}
		if (value === '' || (regex.test(value) && parseFloat(value) <= 2000)) {
			handleInputChange(index, value);
		}
	};

	const handleBlur = (event: React.FocusEvent<HTMLInputElement>) => {
		const numberValue = parseFloat(event.target.value);
		if (!isNaN(numberValue)) {
			handleInputChange(index, numberValue.toFixed(2));
		}
	};

	return <PurchaseTotalTextInputField type="text" value={value} onChange={handleChange} onBlur={handleBlur} />;
};

const PurchaseTotalTextInputField = styled.input`
	display: flex;
	height: 40px;
	width: 100%;
	padding: 16px;
	flex-direction: column;
	justify-content: center;
	align-items: flex-end;
	align-self: stretch;
	text-align: right;
	font-family: 'museo-sans';
	font-size: 16px;
	font-style: normal;
	font-weight: 400;
	line-height: 19px;
	color: #333;
	box-sizing: border-box;
	border-radius: 4px;
	border: 1px solid #919191;
	background: #ffffff;
`;

export default PurchaseTotalTextInput;
